<script setup>
import dayjs from "dayjs";
import BlogLayout from "@/Layouts/BlogLayout.vue";
</script>
<template>
    <Head>
        <title>The Gift Hero Blog</title>
        <link rel="canonical" :href="route('blog.index')" />
        <meta name="title" content="The Gift Hero Blog" />
        <meta
            name="description"
            content="The Best Wish List Ever™ Where you can create a wish list, add items from anywhere, share with anyone."
        />
        <meta property="og:title" content="The Gift Hero Blog" />
        <meta property="og:url" :content="route('blog.index')" />
        <meta
            property="og:image"
            content="https://s3.amazonaws.com/static01.gifthero.com/blog/medium/max/1200/1*WZCqNeXXgc0mq729lCkkPA.png"
        />
        <meta
            property="og:description"
            content="The Best Wish List Ever™ Where you can create a wish list, add items from anywhere, share with anyone."
        />
        <meta
            name="twitter:description"
            content="The Best Wish List Ever™ Where you can create a wish list, add items from anywhere, share with anyone."
        />
        <meta
            name="twitter:image:src"
            content="https://s3.amazonaws.com/static01.gifthero.com/blog/medium/max/1200/1*WZCqNeXXgc0mq729lCkkPA.png"
        />
        <meta property="author" content="Gift Hero" />
        <meta property="og:type" content="article" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
            property="article:publisher"
            content="https://www.facebook.com/gifthero"
        />
        <meta name="robots" content="index, follow" />
        <meta name="twitter:creator" content="@GiftHero" />
        <meta name="twitter:site" content="@gifthero" />
        <meta property="og:site_name" content="Gift Hero" />
        <component is="script" type="application/ld+json">
            { "@context": "http://schema.org", "@type": "WebSite", "url":
            "https:\/\/www.\/gifthero.com\/blog", "name": "Gift Hero",
            "alternateName": "The Best Wish List Ever™ Where you can create a
            wish list, add items from anywhere, share with anyone." }
        </component>
    </Head>
    <BlogLayout>
        <main class="main has-white-bg" role="main">
            <div class="hero">
                <header
                    class="hero__container hero__container--no-photo container-wide stacked-children"
                >
                    <h1 class="hero__title">Gift Hero Blog</h1>
                </header>
            </div>
            <div
                class="container-wide stacked-children whitespace-bottom whitespace-top"
            >
                <article
                    class="blog blog-article blog-listing"
                    v-for="post in $page.props.posts"
                >
                    <Link :href="route('blog.show', { slug: post.slug })">
                        <figure
                            class="blog-listing__preview-image"
                            v-if="post.headerBannerUrl"
                        >
                            <img
                                :src="post.headerBannerUrl"
                                :title="post.headerBannerTitle"
                            />
                        </figure>
                        <time
                            class="blog-datetime"
                            :datetime="post.createdAd"
                            >{{
                                dayjs(post.createdAt).format("MMM D, YYYY")
                            }}</time
                        >
                        <h2 class="blog-listing__title">{{ post.title }}</h2>
                        <h4 class="blog-listing__subhead" v-if="post.subtitle">
                            {{ post.subtitle }}
                        </h4>
                        <p class="blog-listing__more">Read More&hellip;</p>
                    </Link>
                </article>
            </div>
        </main>
    </BlogLayout>
</template>
